module.exports = {
	"about_sidebar_title": {
		"cs-CZ": "O souboru",
		"en-GB": "About us",
		"fr-FR": "Notre ensemble",
		"de-DE": "Musik"
	},
	"about_sidebar_text": {
		"cs-CZ": "Jsme vokálně–instrumentální soubor, který se zaměřuje především na interpretaci hudby z období gotiky, renesance a baroka. Vystupuje převážně v menších kostelech a komorních sálech, kde stará hudba nachází nejvhodnější duchovní dimenzi. Máme za sebou desítky vystoupení v Čechách a na Moravě.",
		"en-GB": "We are a vocal-instrumental ensemble that focuses mainly on the interpretation of music from the Gothic, Renaissance and Baroque periods. We perform mainly in smaller churches and chamber halls where old music finds the most appropriate spiritual dimension. We have had dozens of performances in Bohemia and Moravia.",
		"fr-FR": "Nous sommes un ensemble musical, vocal et instrumental, spécialisé dans le répertoire de la musique des périodes gothique, Renaissance et baroque. Nous nous produisons principalement dans de petites églises et des salles de chambre où la musique ancienne trouve la dimension spirituelle la plus appropriée. Nous avons eu des dizaines de représentations en Bohême et en Moravie.",
		"de-DE": "Wir sind ein Musik-, Vokal- und Instrumentalensemble, das sich auf das Repertoire von Musik aus der Gotik, Renaissance und dem Barock spezialisiert hat. Wir treten hauptsächlich in kleinen Kirchen und Kammermusiksälen auf, wo die Alte Musik die angemessenste spirituelle Dimension findet. Wir hatten Dutzende von Auftritten in Böhmen und Mähren."
	},
	"concerts_sidebar_title": {
		"cs-CZ": "Koncerty",
		"en-GB": "Concerts",
		"fr-FR": "Concerts",
		"de-DE": "Konzertwessen"
	},
	"concerts_sidebar_empty": {
		"cs-CZ": "momentálně nejsou plánovány žádné koncerty",
		"en-GB": "no concerts are currently planned",
		"fr-FR": "aucun concert n'est prévu pour l'instant",
		"de-DE": "derzeit sind keine Konzerte geplant"
	},
	"player_sidebar_title": {
		"cs-CZ": "Audio ukázky",
		"en-GB": "Audio samples",
		"fr-FR": "Extraits audio",
		"de-DE": "Hörproben"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Sidebar/sidebar.json
// module id = 8
// module chunks = 0